export default __webpack_public_path__ + "static/media/warning--u-turn--g1.c962ec41.png";